import { Link } from "react-router-dom";
import { hotTopics } from "@/mocks/topics";
import StatusBadge from "@/components/feature/StatusBadge";
import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/feature/Reveal";

export default function HotRanking() {
  const featured = hotTopics[0];
  const rest = hotTopics.slice(1);

  return (
    <section className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20 lg:px-12">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="热度实时更新"
            title="今日热榜 · 大家都在追的瓜"
            desc="按近 24 小时的阅读与讨论热度排序，每小时刷新一次，先把最热的几件事看明白。"
          />
          <Link
            to="/topics"
            className="inline-flex shrink-0 cursor-pointer items-center gap-1.5 self-start whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600 md:self-auto"
          >
            全部事件复盘
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </span>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <article className="group h-full overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <Link to={`/topics/${featured.id}`} className="block cursor-pointer">
                <div className="relative h-56 w-full overflow-hidden bg-background-200 md:h-80">
                  <img
                    src={featured.cover}
                    alt={`${featured.title}配图`}
                    title={`${featured.title} - 诱惑吃瓜事件复盘`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent"></div>
                  <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="rounded-full bg-accent-500 px-2.5 py-1 text-[11px] font-bold text-foreground-950">
                        热榜第一
                      </span>
                      <StatusBadge status={featured.status} size="md" />
                    </div>
                    <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-background-50 md:text-2xl">
                      {featured.title}
                    </h3>
                  </div>
                </div>
              </Link>
              <div className="p-5 md:p-6">
                <p className="text-sm leading-relaxed text-foreground-600">
                  {featured.summary}
                </p>
                <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
                  <span>{featured.date}</span>
                  <span>{featured.readTime}</span>
                  <span className="flex items-center gap-1.5">
                    <span className="flex h-4 w-4 items-center justify-center text-primary-500">
                      <i className="ri-fire-line" aria-hidden="true"></i>
                    </span>
                    热度 {featured.heat.toLocaleString()}
                  </span>
                </div>
              </div>
            </article>
          </Reveal>

          <Reveal delay={80} className="lg:col-span-5">
            <div className="h-full rounded-lg border border-background-200 bg-background-100 p-2 md:p-3">
              <ol className="flex h-full flex-col">
                {rest.map((topic, index) => (
                  <li key={topic.id} className="flex-1">
                    <Link
                      to={`/topics/${topic.id}`}
                      className="flex h-full cursor-pointer items-start gap-3 rounded-md p-3 transition-colors hover:bg-background-50 md:gap-4 md:p-4"
                    >
                      <span
                        className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                          index === 0
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-50 text-foreground-700"
                        }`}
                      >
                        {index + 2}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="flex flex-wrap items-center gap-2 text-[11px] text-foreground-500">
                          <span>{topic.category}</span>
                          <StatusBadge status={topic.status} />
                        </span>
                        <span className="mt-1.5 block font-heading text-sm font-semibold leading-snug text-foreground-950 md:text-base">
                          {topic.title}
                        </span>
                        <span className="mt-1.5 flex items-center gap-1.5 text-xs text-foreground-500">
                          <span className="flex h-3.5 w-3.5 items-center justify-center text-primary-500">
                            <i className="ri-fire-line" aria-hidden="true"></i>
                          </span>
                          {topic.heat.toLocaleString()}
                        </span>
                      </span>
                    </Link>
                  </li>
                ))}
              </ol>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}